import React from "react";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody, TableHead } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";

function getIpStatAddr(address, unreachableadresses, classes) {
  let cellValue = "";
  let unreachable = false;
  if (address && address.length > 0 && unreachableadresses && unreachableadresses.length > 0) {
    let unreachables = unreachableadresses.split(",");
    if (unreachables && (unreachables.length > 0) && (unreachables.indexOf(address) >= 0)) {
      unreachable = true;
    }
  }
  return (
    <TableCell className={unreachable ? classes.error_tablecontent_first : classes.tablecontent_first}>
      {address}
    </TableCell>
  );
}

const IPTab = props => (
  <Grid container spacing={40}>
    {!props.hideDisclaimer && (
    <Grid item xs={12}>
      <Typography color="inherit" className={props.classes.disclaimer}>
        {props.translate("result_disclaimer")}
      </Typography>
    </Grid>
    )}
    <Grid item xs={6}>
      <Table className={props.classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={props.classes.tableheader_first}>
              {props.translate("result_ipv4")}
            </TableCell>
            <TableCell className={props.classes.tableheader_first}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("status") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv4 &&
                props.subtestStatsResults.ip.ipv4.status &&
                props.subtestStatsResults.ip.ipv4.status}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_address") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv4 &&
                props.subtestStatsResults.ip.ipv4.address &&
                props.subtestStatsResults.ip.ipv4.address}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_netmask") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv4 &&
                props.subtestStatsResults.ip.ipv4.netmask &&
                props.subtestStatsResults.ip.ipv4.netmask}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_gateway") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv4 &&
             props.subtestStatsResults.ip.ipv4.gateway &&
             props.subtestStatsResults.ip.ipv4.gateway ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv4.gateway, props.subtestStatsResults.ip.ipv4.unreachableaddresses, props.classes) : ""}
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_dnsprim") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv4 &&
             props.subtestStatsResults.ip.ipv4.dnsprimary &&
             props.subtestStatsResults.ip.ipv4.dnsprimary ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv4.dnsprimary, props.subtestStatsResults.ip.ipv4.unreachableaddresses, props.classes) : ""}
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_dnssec") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv4 &&
             props.subtestStatsResults.ip.ipv4.dnssecondary &&
             props.subtestStatsResults.ip.ipv4.dnssecondary ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv4.dnssecondary, props.subtestStatsResults.ip.ipv4.unreachableaddresses, props.classes) : ""}
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_dhcp") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv4 &&
             props.subtestStatsResults.ip.ipv4.dhcpserver &&
             props.subtestStatsResults.ip.ipv4.dhcpserver ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv4.dhcpserver, props.subtestStatsResults.ip.ipv4.unreachableaddresses, props.classes) : ""}
          </TableRow>
        </TableBody>
      </Table>
    </Grid>
    <Grid item xs={6}>
      <Table className={props.classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={props.classes.tableheader_first}>
              {props.translate("result_ipv6")}
            </TableCell>
            <TableCell className={props.classes.tableheader_first}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("status") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv6 &&
                props.subtestStatsResults.ip.ipv6.status &&
                props.subtestStatsResults.ip.ipv6.status}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_address") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv6 &&
                props.subtestStatsResults.ip.ipv6.address &&
                props.subtestStatsResults.ip.ipv6.address}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_nw_prefix") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv6 &&
                props.subtestStatsResults.ip.ipv6.prefix &&
                props.subtestStatsResults.ip.ipv6.prefix}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_link_add") + ":"}
            </TableCell>
            <TableCell className={props.classes.tablecontent_first}>
              {props.subtestStatsResults.ip.ipv6 &&
                props.subtestStatsResults.ip.ipv6.linkaddress &&
                props.subtestStatsResults.ip.ipv6.linkaddress}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_gateway") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv6 &&
             props.subtestStatsResults.ip.ipv6.gateway &&
             props.subtestStatsResults.ip.ipv6.gateway ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv6.gateway, props.subtestStatsResults.ip.ipv6.unreachableaddresses, props.classes) : ""}
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_dnsprim") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv6 &&
             props.subtestStatsResults.ip.ipv6.dnsprimary &&
             props.subtestStatsResults.ip.ipv6.dnsprimary ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv6.dnsprimary, props.subtestStatsResults.ip.ipv6.unreachableaddresses, props.classes) : ""}
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_dnssec") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv6 &&
             props.subtestStatsResults.ip.ipv6.dnssecondary &&
             props.subtestStatsResults.ip.ipv6.dnssecondary ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv6.dnssecondary, props.subtestStatsResults.ip.ipv6.unreachableaddresses, props.classes) : ""}
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tablecontent_first}>
              {props.translate("result_dhcp") + ":"}
            </TableCell>
            {props.subtestStatsResults.ip.ipv6 &&
             props.subtestStatsResults.ip.ipv6.dhcpserver &&
             props.subtestStatsResults.ip.ipv6.dhcpserver ?
             getIpStatAddr(props.subtestStatsResults.ip.ipv6.dhcpserver, props.subtestStatsResults.ip.ipv6.unreachableaddresses, props.classes) : ""}
          </TableRow>
        </TableBody>
      </Table>
    </Grid>
  </Grid>
);
export default withStyles(styles)(IPTab);
